import { addSeconds } from 'date-fns'

const STORAGE_KEY = 'escribonauta_email_verification_cooldown_until'

export const EMAIL_VERIFICATION_COOLDOWN_SECONDS = 60

export function startEmailVerificationCooldown(
  seconds: number = EMAIL_VERIFICATION_COOLDOWN_SECONDS,
): Date {
  const cooldownUntil = addSeconds(new Date(), seconds)
  localStorage.setItem(STORAGE_KEY, cooldownUntil.toISOString())
  return cooldownUntil
}

export function readEmailVerificationCooldown(): Date | null {
  const storedValue = localStorage.getItem(STORAGE_KEY)
  return storedValue ? new Date(storedValue) : null
}

export function clearEmailVerificationCooldown() {
  localStorage.removeItem(STORAGE_KEY)
}
